import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ApplicationState } from 'store/rootReducer';
import { hasUserAdminRoles } from 'utils/bzmUserConfigUtil';
import AdminSidebar from './AdminSidebar';
import UsageReport from './UsageReport/UsageReport';
import RoiInsights from './RoiInsights/RoiInsights';
import AutoShutdownSettings from './AutoShutdownSettings/AutoShutdownSettings';
import MemorySettings from './MemorySettings/MemorySettings';
import AuditLog from './AuditLog/AuditLog';
import './Admin.scss';

const Admin: React.FC = () => {
  const blazeUserConfig = useSelector((state: ApplicationState) => state.blazeUserConfig.blazeUserConfig);

  if (!hasUserAdminRoles(blazeUserConfig)) {
    return <Redirect to="/mock-services" />;
  }

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <main className="admin-content">
        <Switch>
          <Route path="/admin/usage-report" component={UsageReport} />
          <Route path="/admin/roi-insights" component={RoiInsights} />
          <Route path="/admin/auto-shutdown-settings" component={AutoShutdownSettings} />
          <Route path="/admin/memory-settings" component={MemorySettings} />
          <Route path="/admin/audit-log" component={AuditLog} />
          <Redirect from="/admin" exact to="/admin/usage-report" />
          <Redirect to="/admin/usage-report" />
        </Switch>
      </main>
    </div>
  );
};

export default Admin;
